import React, { useState } from "react";
import { Period } from "@linkfluence/models/date";
import { Timezone } from "@linkfluence/models/timezone";
import { Card } from "@radarly/models/cards";
import { Clause } from "@radarly/models/clause";
import { pasteFiltersOnCard } from "@radarly/models/insight-pages/editor";
import Charts from "./card-library";
import Form from "./form";

interface SharedPanelsCardEditionPanelProps {
  onClose: () => void;
  onValidate: (card: Card) => void;
  card: Card;
  timezone: Timezone;
  aiContext: string;
  setAIContext: (description: string) => void;
  globalPeriod?: Period;
  pageColors?: string[];
}

export default function SharedPanelsCardEditionPanel({
  onClose,
  card,
  onValidate,
  timezone,
  aiContext,
  setAIContext,
  pageColors,
}: SharedPanelsCardEditionPanelProps) {
  const [_card, setCard] = useState(card);
  const onPasteFilters = (clause: Clause) => {
    const newCard = pasteFiltersOnCard(_card, clause);
    setCard(newCard);
  };

  return _card ? (
    <Form
      onPasteFilters={onPasteFilters}
      card={_card}
      setCard={setCard}
      onClose={onClose}
      aiContext={aiContext}
      setAIContext={setAIContext}
      onValidate={() => onValidate(_card)}
      timezone={timezone}
      pageColors={pageColors}
    />
  ) : (
    <Charts addCard={setCard} onClose={onClose} />
  );
}
